<template>
  <div>
    <div id="user-center">
      <a href="#/personal">
        <div id="uc-options">
          <b-img
              :src="whiteArrowImg"
              id="enterUC"
          ></b-img>
        </div>
      </a>
      <b-img
          :src="centerBgImg"
          class="sidebar-card"></b-img>
      <p class="sidebar-text">个人中心</p>
    </div>
    <div id="health-manage">
      <div id="hm-options" class="enterGrid4">
        <a class="enterOpt4" href="#/overview">接种概况</a>
        <a class="enterOpt4" href="#/complete">已接种</a>
        <a class="enterOpt4" href="#/incomplete">未接种</a>
        <a class="enterOpt4" href="#/suggest">建议接种</a>
      </div>
      <b-img
          :src="healthBgImg"
          class="sidebar-card"></b-img>
      <p class="sidebar-text">健康管理</p>
    </div>
    <div id="vac-book">
      <div id="vac-options" class="enterGrid4">
        <a class="enterOpt4" href="#/type">疫苗种类</a>
        <a class="enterOpt4" href="#/nearby">附近医院</a>
        <a class="enterOpt4" href="#/search">搜索</a>
        <a class="enterOpt4" href="#/appointment">所有预约</a>
      </div>
      <b-img
          :src="bookBgImg"
          class="sidebar-card"></b-img>
      <p class="sidebar-text">接种预约</p>
    </div>
  </div>
</template>

<script>
import common from "@/common";

export default {
  name: "SideBar",
  data() {
    return {
      centerBgImg: common.centerBgImgSrc,
      healthBgImg: common.healthBgImgSrc,
      bookBgImg: common.bookBgImgSrc,
      whiteArrowImg: common.whiteArrowImgSrc,
    }
  }
}
</script>


<style scoped src="../main.css"/>